import {Alert, Box, Button, Link as MuiLink, Stack, TextField, Typography} from '@mui/material';
import React, {useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {API_ENDPOINT} from '../config';
import AltchaVerification from '../components/AltchaVerification';

// Pasul 39: „Ai uitat parola?”. Serverul răspunde la fel indiferent dacă adresa are cont.
export default function ParolaUitataPage() {
    const [email, setEmail] = useState('');
    const [altcha, setAltcha] = useState('');
    // Soluția ALTCHA se consumă la fiecare încercare: widget remontat după orice răspuns.
    const [captchaVersion, setCaptchaVersion] = useState(0);
    const [error, setError] = useState('');
    const [sent, setSent] = useState('');
    const [busy, setBusy] = useState(false);
    const pending = useRef(false);
    const submit = async event => {
        event.preventDefault();
        if (pending.current || !altcha) return;
        pending.current = true;
        setBusy(true);
        setError('');
        try {
            const {data} = await axios.post(`${API_ENDPOINT}/public/parola-uitata`, {email: email.trim(), altcha});
            setSent(data?.detail || 'Dacă adresa are un cont ArtaNFT activ, vei primi în câteva minute un email cu linkul de resetare.');
        } catch (e) {
            setError(e.response?.data?.detail || 'Cererea nu a reușit. Reîncearcă.');
        } finally {
            pending.current = false;
            setBusy(false);
            setAltcha('');
            setCaptchaVersion(v => v + 1);
        }
    };
    return <Box sx={{maxWidth: 520, mx: 'auto', px: 2, py: 5}}>
        <Typography component="h1" variant="h4" sx={{mb: 2}}>Ai uitat parola?</Typography>
        {sent ? <Alert severity="success" role="status">{sent}</Alert>
            : <Stack component="form" onSubmit={submit} spacing={3}>
                <Typography sx={{color: 'text.secondary'}}>Introdu emailul contului și îți trimitem un link pentru a alege o parolă nouă. Parola actuală rămâne valabilă până atunci.</Typography>
                {error && <Alert severity="error">{error}</Alert>}
                <TextField label="Email" type="email" autoComplete="email" required value={email}
                    onChange={e => setEmail(e.target.value)} disabled={busy} inputProps={{'aria-label': 'Email', maxLength: 180}} />
                <AltchaVerification key={captchaVersion} onVerified={setAltcha} />
                <Button type="submit" variant="contained" disabled={busy || !altcha}>{busy ? 'Se trimite…' : 'Trimite linkul'}</Button>
            </Stack>}
        <Box sx={{mt: 3}}>
            <MuiLink component={Link} to="/login" underline="hover">← Autentificare</MuiLink>
        </Box>
    </Box>;
}
